import React from 'react';

import { BaseIconProps } from '.';

export const HouseHero = ({ fill }: BaseIconProps) => (
  <g
    transform="matrix(24.545455,0,0,24.545455,-1e-5,49.0909)"
    strokeWidth="0.04074074"
  >
    <path
      fill={fill}
      strokeWidth="0.04074074"
      d="m 24.2,22.222 v 8.89 H 33 v -8.89 z M 14.3,4.666 22,15.556 h 15.4 v 20 H 19.8 V 22.222 H 11 V 35.556 H 6.6 v -20 z M 11,0 0,15.556 H 2.2 V 40 H 41.8 V 15.556 H 44 L 33,0 Z"
    />
  </g>
);
